import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import SellerFormValidation from '../../validations/SellerFormValidation'
import Grid from '@mui/material/Grid';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';


function SellerReqOtpToLoginForm() {

    const [searchParams, setSearchParams] = useSearchParams()

    const initialValues = {
        'mob_number': searchParams.get('mob_number') || '',
    }
    const [reqPayload, setReqPayload] = React.useState(initialValues);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onSubmit = values => {
        // console.log('---onSubmit--values:', values);
        submitEmpLogin(values);
    }

    const formik = useFormik({
        initialValues,
        onSubmit,
        // validate,
        validationSchema: SellerFormValidation.sellerSendOtpToLoginSchema,
        validateOnChange: false
    })

    // console.log('---formik--values:', formik.values);
    // console.log('---formik--errors:', formik.errors);

    const successResponse = (response) => {
        // console.log('---successResponse--response:', response);
        // authUtil.setCredentials('auth-token', response.data.data.auth_token)
        dispatch(setSnackbar({
            status: 'success',
            message: response.data.message
        }))

        navigate('/seller/login?mob_number=' + response.data.data.dataset[0].mob_number)
    }

    const errorResponse = (error) => {
        formik.setErrors({ ...error.response.data.errors })
        // console.log('---errorResponse--formik--errors---221:', formik.errors);
    }

    const submitEmpLogin = async (data, query = {}) => {
        try {
            const response = await callApi.requestPOST(`/sellers-bids/seller/req-otp-to-login`, data)
            // console.log('---submitEmpLogin---response:', response);
            successResponse(response)

        }
        catch (error) {
            // console.log('---submitEmpLogin---error:', error);
            errorResponse(error)
        }
    }


    return (
        <div>
            <Grid >

                <Box component="form" className="" onSubmit={formik.handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <div className="tw-text-lg tw-mb-5"><p>Enter Mobile Number to Receive OTP</p></div>
                            <TextField id="outlined-basic" className="tw-w-full" label="Mobile Number" type="text" name="mob_number" placeholder="9819550001" variant="outlined" onChange={formik.handleChange} value={formik.values.mob_number} error={formik.errors.mob_number ? true : false} helperText={formik.errors.mob_number} inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} required />
                        </Grid>
                    </Grid>

                    <Grid container spacing={5}>
                        <Grid item xs={12} sm={12} className="tw-mt-10">
                            <Button type="submit" variant="contained">Send OTP</Button>
                        </Grid>
                    </Grid>
                </Box>

            </Grid>

            <Snackbar />
        </div>
    );

}


export { SellerReqOtpToLoginForm };
